import React from "react";

import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

// ----------------------------------------------------------------------------

interface KPICardProps {
  title: string;
  value: string;
  trend: string;
  icon: React.ReactNode;
  className?: string;
  isLoading?: boolean;
}

export function KPICard(props: KPICardProps) {

  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { title, value, trend, icon, className, isLoading = false } = props;

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  return (
    <Card className={cn("shadow-sm", className)}>
      <CardContent className="p-6">
        <div className="flex justify-between items-start mb-4">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <div className="text-gray-400">
            {icon}
          </div>
        </div>
        <div>
          {isLoading ? (
            <div className="space-y-2">
              <Skeleton className="h-8 w-28" />
              <Skeleton className="h-3 w-40" />
            </div>
          ) : (
            <>
              <h3 className="text-2xl font-bold text-gray-900">{value}</h3>
              <p className="text-xs text-gray-500 mt-1">{trend}</p>
            </>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
